import * as types from './actionTypes';

export const searchCompaniesData = (title, type) => {
  let searchInput = title;
  let searchType;

  if (title === '') {
    searchInput = '';
  }
  if (type === 'Contacts') {
    searchType = 'contact';
  } else if (type === 'Jobs') {
    searchType = 'job';
  } else {
    searchType = 'company';
  }
  return async (dispatch) => {
    dispatch({
      type: types.SEARCH_COMPANIES_DATA,
      payload: { searchInput, searchType },
    });
  };
};
